import config from 'config';
import { authHeader } from '../_helpers';

export const measurementService = {
    getMeasurementServicesBySupernovaAccountId,
    getConversionDefinitionBySupernovaAccountId,
    getAudiencesBySupernovaAccountId,
    updateConversionDefinition,
    createConversionDefinition
};

function getMeasurementServicesBySupernovaAccountId(supernovaAccountId) {
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json'
        },
    };
    return fetch(`${config.apiURL}/measurement/services/?supernovaAccountId=${supernovaAccountId}`, requestOptions).then(handleResponse);
}
function getConversionDefinitionBySupernovaAccountId(supernovaAccountId) {
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json'
        },
    };
    return fetch(`${config.apiURL}/measurement/conversiondefinitions/?supernovaAccountId=${supernovaAccountId}`, requestOptions).then(handleResponse);
}
function getAudiencesBySupernovaAccountId(supernovaAccountId) {
    const requestOptions = {
        method: 'GET',
        headers: { 
            'Content-Type': 'application/json'
        },
    };
    return fetch(`${config.apiURL}/measurement/audiences/?supernovaAccountId=${supernovaAccountId}`, requestOptions).then(handleResponse);
}

function updateConversionDefinition(data) {
    const requestOptions = {
        method: 'PUT',
        headers: { 
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    };

    return fetch(`${config.apiURL}/measurement/conversiondefinitions/${data.id}/`, requestOptions).then(handleResponse);
}

function createConversionDefinition(data, supernovaAccountId) {
    const requestOptions = {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };

    // return fetch(`${config.apiURL}/pixels`, requestOptions).then(handleResponse);    //NOTE: Pixel is deprecated. Use Measurement instead
    return fetch(`${config.apiURL}/measurement/conversiondefinitions/${supernovaAccountId}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
